export const parseValidationErrors = (errorResponse) => {
  const result = {
    fieldErrors: {},
    generalErrors: [],
  };

  if (!errorResponse || !Array.isArray(errorResponse.errors)) {
    if (errorResponse?.message) {
      result.generalErrors.push(errorResponse.message);
    }
    return result;
  }

  errorResponse.errors.forEach((error) => {
    if (!error.msg) {
      return;
    }

    const hasPath = error.path && error.path.trim() !== '';
    const hasAffectedFields =
      error.affected_fields &&
      Array.isArray(error.affected_fields) &&
      error.affected_fields.length > 0;

    if (hasPath) {
      if (!result.fieldErrors[error.path]) {
        result.fieldErrors[error.path] = error.msg;
      }
    }

    if (hasAffectedFields) {
      error.affected_fields.forEach((fieldName) => {
        if (!result.fieldErrors[fieldName]) {
          result.fieldErrors[fieldName] = error.msg;
        }
      });
    }

    if (!hasPath && !hasAffectedFields) {
      result.generalErrors.push(error.msg);
    }
  });

  return result;
};

export const isValidationError = (errorResponse) => {
  return (
    errorResponse &&
    (errorResponse.error_code === 'VALIDATION_FAILED' ||
      Array.isArray(errorResponse.errors))
  );
};

export const getGeneralErrorMessage = (errorResponse, defaultMessage) => {
  if (!errorResponse) {
    return defaultMessage;
  }

  return (
    errorResponse.message ||
    errorResponse.msg ||
    errorResponse.error ||
    defaultMessage
  );
};
